import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { DropdownButton } from '@sendgrid/ui-components';
import withPackages from '../containers/withPackages';
import withAddOns from '../containers/withAddOns';
import PackageOption from './PackageOption';
import FragmentLoader from './fragmentLoader';
import Styles from './packageselector.module.scss';
import BtnStyles from './summarybutton.module.scss';
import dollarize from '../utils/displayHelpers';
import { ENVIRONMENT } from '../constants';
import getEnvVariable from '../utils/environment';


export class PackageSelector extends Component {
  constructor(props) {
    super(props);
    this.handlePackageClick = this.handlePackageClick.bind(this);
  }

  componentWillMount() {
    const parsedQS = queryString.parse(this.props.location.search);
    this.cuuid = parsedQS.cuuid || '';
    this.id = parsedQS.id || '';
    this.group = parsedQS.group || '';
    // eslint-disable-next-line
    this.link = this.cuuid ? `${getEnvVariable(ENVIRONMENT.MAKO_URL)}/signup/aws?group=60f03dd5-6259-11e7-9630-ecf4bbc2ebd0&cuuid=${this.cuuid}` : 'javascript:void(0)';
    this.props.initializePackages(parsedQS);
  }

  handlePackageClick(uuid) {
    const activePackage = this.props.packages.availablePackages.find(p => p.id === uuid);
    this.props.setPackage(activePackage);
  }

  loadingPackages() {
    this.loadingFrag = (
      <svg className="fragment-loader is-centered">
        <rect className="fragment-square left" width="10" height="10" />
        <rect className="fragment-square middle" width="10" height="10" />
        <rect className="fragment-square right" width="10" height="10" />
      </svg>
    );
    return this.loadingFrag;
  }

  renderPackages() {
    return this.props.packages.availablePackages.map(p => (
      <PackageOption
        uuid={p.id}
        onClick={this.handlePackageClick}
        datarole={p.dataRole}
        key={p.id}
      >
        <div>
          <div className={Styles.option}>
            {p.name}
          </div>
          <div className={Styles['option-price']}>
            {dollarize(p.base_price)}
          </div>
        </div>
      </PackageOption>
    ));
  }

  render() {
    return !this.props.packages.activePackage.is_aws && !(this.id && this.group) ?
      <div className={`${BtnStyles['btn-signup']} ${Styles['pkg-select']}`}>
        <DropdownButton
          label={this.props.packages.activePackage.name}
          type="secondary"
          id="active-package"
          data-role="package-dropdown"
          disabled={this.props.location.pathname.indexOf('billing') > -1}
        >
          {
          this.props.packages.packagesLoaded || this.props.packages.activePackage.is_aws ?
           this.renderPackages() :
           <FragmentLoader />

        }
        </DropdownButton>
      </div>

      :
      <div className={Styles['aws-package']}>Plan :{' '}
        <a href={this.link}>
          {this.props.packages.activePackage.id ? this.props.packages.activePackage.name : 'No Package Selected'}
        </a>
      </div>;
  }
}

PackageSelector.propTypes = {
  packages: PropTypes.shape({
    availablePackages: PropTypes.array.isRequired,
    packagesLoaded: PropTypes.bool.isRequired,
    activePackage: PropTypes.object.isRequired,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  setPackage: PropTypes.func.isRequired,
  initializePackages: PropTypes.func.isRequired,
};

export default withRouter(withPackages(withAddOns(PackageSelector)));



// WEBPACK FOOTER //
// ./src/components/PackageSelector.jsx